import React, { useEffect } from 'react'
import ImageWithBasePath from '../../../../../core/common/imageWithBasePath'
import { Link } from 'react-router-dom'

const AcceptanceOfPlans = ({ printOutPdfDetails,onRenderReady,targetRef }: any) => {

    useEffect(() => {
        if (printOutPdfDetails) {
            onRenderReady?.();
        }
    }, [printOutPdfDetails]);

    return (
        <div className='row' id='AcceptanceOfPlans' ref={targetRef} style={{ pageBreakAfter: "always" }}>
            <div className='col-md-12 px-5'>
                <div className='d-flex justify-content-center align-items-center mt-4'>
                    <ImageWithBasePath
                        src="assets/img/logo.svg"
                        className=""
                        alt="Logo"
                        width={300}
                        height={68}
                    />
                </div>
                <p className='text-center fw-bold'>
                    ACCEPTANCE OF PLANS
                </p>
            </div>
            <div className='px-5 mt-3'>
                <div className='d-flex'>
                    <p className='w-20 mb-0'>
                        Client Name:
                    </p>
                    <p className='mb-0'>
                        {printOutPdfDetails?.primaryContactFirstName} {printOutPdfDetails?.primaryContactLastName}
                        {printOutPdfDetails?.secondaryContactFirstName ? ' and ' : ''}
                        {printOutPdfDetails?.secondaryContactFirstName} {printOutPdfDetails?.secondaryContactLastName}
                    </p>
                </div>
                <div className='d-flex'>
                    <div>
                        <p className='w-20 mb-0'>
                            Address:
                        </p>
                    </div>
                    <div>
                        <p className='mb-0'>
                            {printOutPdfDetails?.mailingAddressLine1} {" "}
                        </p>
                        <p className='mb-0'>
                            {printOutPdfDetails?.mailingAddressLine2} {" "}
                        </p>
                        <p className='mb-0'>
                            {printOutPdfDetails?.mailingCity} {" "} {printOutPdfDetails?.mailingState ? ',' : ''} {" "} {printOutPdfDetails?.mailingState} {" "}  {printOutPdfDetails?.mailingZipCode}
                        </p>
                    </div>
                </div>
                <div className='d-flex'>
                    <p className='w-20 mb-0'>
                        Project Number:
                    </p>
                    <p className='mb-0'>
                        {printOutPdfDetails?.projectNumber}
                    </p>
                </div>
                <div className='mt-3'>
                    <p>
                        The undersigned,
                        <b> {" "}
                            {printOutPdfDetails?.primaryContactFirstName} {printOutPdfDetails?.primaryContactLastName}
                            {printOutPdfDetails?.secondaryContactFirstName ? ' and ' : ''}
                            {printOutPdfDetails?.secondaryContactFirstName} {printOutPdfDetails?.secondaryContactLastName}
                        </b>
                        {" "}
                        , (“Buyer”) as of 04/28/2025 (the “acceptance date”) hereby approve(s) the plans (the “plans”), attached hereto, and prepared by Airoom Architects, Corp., in connection with that certain Sales Contract by and between Airoom, LLC. (“Airoom”) and Buyer for the work to be performed at (the “Property”), as the final and approved plans.  Buyer hereby grants approval to Airoom to order materials based on the design and material selections set forth in the plans and attached signed documents.
                        <br />
                        <br />

                        <b>Buyer understands, acknowledges and agrees that any changes to the plans requested by Buyer, after the Acceptance Date, will result in additional costs to Buyer, and Buyer agrees to be responsible for same.  In such case Buyer shall be responsible for: (i) additional charges, based on an hourly rate of $150.00, per hour, to make any drawing or other changes to the plans or design and material selections; (ii) charges assessed to repurchase materials; (iii) any restocking fee or manufacture penalties assessed because of a changed or cancelled order; and/or (iv) any other fee, cost, charge or expense assessed Airoom that are the result of Buyer’s changes to the plans.  Buyer agrees to pay these additional charges upon receipt of an invoice from Airoom for same.</b>
                        <br />
                        <br />

                        Buyer also understands, acknowledges and agrees that Airoom shall not be responsible if construction shall be delayed or prevented by changes to the plans requested by Buyer after the Acceptance Date or because of delays in the delivery of any material selections made after the Acceptance Date.IN WITNESS WHEREOF, Buyer has executed this Acceptance of Plans, this date, Monday, April 28, 2025.
                    </p>
                </div>
                <div className='d-flex gap-3 mt-2'>
                    <div>
                        <p>
                            Buyer:
                        </p>
                    </div>
                    <div>
                        <p>
                            X _______________________
                        </p>
                        <p>
                            X _______________________
                        </p>
                    </div>
                </div>
                <div className='mt-3'>
                    <p className='mb-0'>
                        Accepted :

                    </p>
                    <p >
                        AIROOM, LLC.

                    </p>
                    <p>
                        By : <span className='ms-4'>____________________</span>
                    </p>
                </div>
                <div className='text-center mt-5'>
                    <p className='mb-0'>
                        <b>
                            CORPORATE OFFICES AND DESIGN CENTER {" "}
                        </b>
                        6825 N. Lincoln Ave., Lincolnwood, IL 60712 <b> BRANCH OFFICE</b> Hinsdale, IL
                    </p>
                    <p>
                        <b>AIROOM INC.</b> - 847.967.ROOM - 847.763.1101 (fax) - <Link to="https:/www.airoom.com" className='text-decoration-underline text-primary'>www.airoom.com</Link>
                    </p>
                </div>
            </div>

        </div>
    )
}

export default AcceptanceOfPlans